import { render, staticRenderFns } from "./UpdateCourse.vue?vue&type=template&id=68995f4d"
import script from "./UpdateCourse.vue?vue&type=script&lang=js"
export * from "./UpdateCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports